/* LUVEE theme — cart drawer + AJAX add-to-cart */
(function () {
  const $ = (s) => document.querySelector(s);
  const overlay = $('#overlay'), drawer = $('#cart-drawer'), mnav = $('#m-nav');
  const money = (c) => '₹' + (c / 100).toLocaleString('en-IN');

  function openDrawer() { renderCart(); drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  function openMenu() { if (!mnav) return; mnav.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; const t = $('#menu-toggle'); if (t) t.setAttribute('aria-expanded', 'true'); }
  function closeMenu() { if (mnav) mnav.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; const t = $('#menu-toggle'); if (t) t.setAttribute('aria-expanded', 'false'); }
  function closeAll() { closeDrawer(); closeMenu(); }

  /* Free surprise gift — display only, mirrors snippets/cart-gift.liquid on the cart page.
     Never rendered for an empty bag (renderCart returns before this) and never sent to
     /cart/add.js: nothing is added, nothing is discounted, no stock moves. The gift is
     packed by hand. Copy + on/off come from theme settings via window.LUVEE.gift. */
  function giftRow() {
    const g = (window.LUVEE && window.LUVEE.gift) || {};
    if (!g.on) return '';
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    return `
      <div style="display:flex;gap:12px;align-items:center;padding:14px 0 4px;margin-top:4px;border-top:1px dashed var(--accent)">
        <div style="flex:none;width:40px;height:40px;border-radius:9px;background:#fff;border:1px dashed var(--accent);display:flex;align-items:center;justify-content:center;font-size:19px">🎁</div>
        <div style="flex:1;min-width:0">
          <div style="font-size:13.5px;font-weight:600;line-height:1.3">${esc(g.title)}</div>
          <div class="muted" style="font-size:12px;margin-top:2px">${esc(g.sub)}</div>
        </div>
        <div style="font-size:11.5px;font-weight:700;letter-spacing:.08em;color:var(--accent);white-space:nowrap">FREE</div>
      </div>`;
  }

  async function renderCart() {
    const body = $('#drawer-body'), foot = $('#drawer-foot');
    const cart = await fetch('/cart.js').then((r) => r.json());
    updateCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<div style="text-align:center;padding:56px 20px"><p style="font-size:30px;margin:0 0 10px">🛍️</p><p style="font-weight:600;margin:0 0 6px">Your bag is feeling light</p><p class="muted" style="font-size:14px;margin:0 0 18px">Let\'s fix that — something lovely is waiting.</p><a href="/collections/bestsellers" class="btn">Browse bestsellers</a></div>';
      foot.innerHTML = ''; return;
    }
    body.innerHTML = cart.items.map((i) => `
      <div style="display:flex;gap:14px;padding:15px 0;border-bottom:1px solid var(--line)">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''}" alt="" style="width:70px;height:70px;object-fit:contain;background:#fff;border:1px solid var(--line);border-radius:8px;padding:5px">
        <div style="flex:1">
          <div style="font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--accent)">${i.vendor || ''}</div>
          <div style="font-size:14px;font-weight:600;line-height:1.3;margin:2px 0 6px">${i.product_title}</div>
          <div style="display:inline-flex;align-items:center;border:1px solid var(--line);border-radius:40px">
            <button data-qty="${i.key}" data-d="-1" style="width:28px;height:28px">−</button>
            <span style="width:30px;text-align:center;font-size:13px">${i.quantity}</span>
            <button data-qty="${i.key}" data-d="1" style="width:28px;height:28px">+</button>
          </div>
        </div>
        <div style="font-weight:600;font-size:14px;white-space:nowrap">${money(i.final_line_price)}</div>
      </div>`).join('') + giftRow();
    foot.innerHTML = `
      <div style="display:flex;justify-content:space-between;font-size:18px;font-weight:600;margin-bottom:12px"><span>Total</span><span>${money(cart.total_price)}</span></div>
      ${window.LUVEE.ordersOpen
        ? '<a href="/checkout" class="btn btn--block">Checkout</a>'
        : '<div style="background:var(--accent-soft);color:var(--accent-dark);font-size:13px;padding:10px 12px;border-radius:8px;text-align:center">We\'re not taking orders yet — launching soon.</div>'}`;
  }

  function updateCount(n) {
    const el = $('#cart-count'); if (!el) return;
    el.textContent = n; el.hidden = n === 0;
  }

  async function addToCart(id) {
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity: 1 }) });
    openDrawer();
  }
  async function changeQty(key, d) {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const item = cart.items.find((i) => i.key === key); if (!item) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, item.quantity + d) }) });
    renderCart();
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-add],[data-qty],#cart-toggle,#drawer-close,#menu-toggle,#m-nav-close');
    if (!t) return;
    if (t.dataset.add !== undefined) { e.preventDefault(); addToCart(+t.dataset.add); }
    else if (t.dataset.qty !== undefined) { changeQty(t.dataset.qty, +t.dataset.d); }
    else if (t.id === 'cart-toggle') { e.preventDefault(); openDrawer(); }
    else if (t.id === 'drawer-close') { closeDrawer(); }
    else if (t.id === 'menu-toggle') { e.preventDefault(); openMenu(); }
    else if (t.id === 'm-nav-close') { closeMenu(); }
  });
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* search suggestions — recent (localStorage) + trending, shown on click/focus */
  (function () {
    const form = $('#hdr-search'), input = $('#hdr-search-input'), panel = $('#search-sugg');
    if (!form || !input || !panel) return;
    const KEY = 'luvee-recent-searches';
    const recentWrap = $('#sugg-recent'), recentChips = $('#sugg-recent-chips'), clearBtn = $('#sugg-clear');
    const liveWrap = $('#sugg-live'), trendWrap = $('#sugg-trend');

    const getRecent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
    const saveTerm = (t) => {
      t = (t || '').trim(); if (!t) return;
      try {
        const list = [t, ...getRecent().filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, 6);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch {}
    };
    const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    function renderRecent() {
      const list = getRecent();
      recentWrap.hidden = list.length === 0;
      recentChips.innerHTML = list.map((t) => `
        <a class="search__chip search__chip--recent" href="/search?q=${encodeURIComponent(t)}&type=product" data-sugg-term="${esc(t)}">
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>${esc(t)}
        </a>`).join('');
    }
    function showPanel() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function browseMode() { liveWrap.hidden = true; if (trendWrap) trendWrap.hidden = false; renderRecent(); showPanel(); }
    function open() { input.value.trim() === '' ? browseMode() : liveMode(input.value.trim()); }

    /* live predictive results via Shopify's Predictive Search API */
    const money = (v) => '₹' + Number(v).toLocaleString('en-IN');
    let debounceT = null, ctrl = null, lastTerm = '';
    function liveMode(term) {
      if (term === lastTerm && !liveWrap.hidden) { showPanel(); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=query,product&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, { signal: ctrl.signal }).then((r) => r.json()).then((d) => {
        lastTerm = term;
        const res = (d.resources && d.resources.results) || {};
        const queries = (res.queries || []).slice(0, 4);
        const products = res.products || [];
        let html = '';
        html += queries.map((q) => `
          <a class="sugg-row sugg-row--q" href="/search?q=${encodeURIComponent(q.text)}&type=product" data-sugg-term="${esc(q.text)}">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <span>${esc(q.text)}</span>
          </a>`).join('');
        html += products.map((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          return `
          <a class="sugg-row sugg-row--p" href="${p.url}">
            ${img ? `<img src="${img.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2')}" alt="" loading="lazy">` : '<span class="sugg-row__ph"></span>'}
            <span class="sugg-row__txt">
              ${p.vendor ? `<small>${esc(p.vendor)}</small>` : ''}
              <span>${esc(p.title)}</span>
            </span>
            <b>${p.price ? money(p.price) : ''}</b>
          </a>`;
        }).join('');
        if (!queries.length && !products.length) {
          html = `<p class="sugg-none">Nothing matched "<b>${esc(term)}</b>" yet — try the brand name, or <a href="/#request">request it</a> and we'll hunt it down.</p>`;
        } else {
          html += `<a class="sugg-all" href="/search?q=${encodeURIComponent(term)}&type=product" data-sugg-term="${esc(term)}">See all results for “${esc(term)}” →</a>`;
        }
        liveWrap.innerHTML = html;
        liveWrap.hidden = false;
        recentWrap.hidden = true;
        if (trendWrap) trendWrap.hidden = true;
        showPanel();
      }).catch(() => {});
    }

    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    input.addEventListener('input', () => {
      const v = input.value.trim();
      clearTimeout(debounceT);
      if (v === '') { browseMode(); return; }
      debounceT = setTimeout(() => liveMode(v), 180);
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    form.addEventListener('submit', () => saveTerm(input.value));
    panel.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-sugg-term]');
      if (chip) saveTerm(chip.dataset.suggTerm);
    });
    if (clearBtn) clearBtn.addEventListener('click', () => { try { localStorage.removeItem(KEY); } catch {} renderRecent(); });
  })();

  /* gentle scroll-reveal for homepage sections (respects reduced motion) */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const els = document.querySelectorAll('main .section, main .hero, main .trust-wrap');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach((el) => { el.classList.add('reveal'); io.observe(el); });

    /* Failsafe: reveal anything already on screen at load.
       `.reveal` sets opacity:0 the instant this runs, and the content only comes back when the
       observer reports an intersection. That callback is not guaranteed — with
       `threshold: 0.06` plus a negative bottom rootMargin, a section that is already in view
       when observation starts can fail to produce an entry, and the content then stays
       invisible forever. It bit the 404 page, whose single short section IS the whole page:
       the error message rendered blank on some loads and fine on others.
       Checking geometry directly on the next frame is deterministic where the observer is not.
       Only elements genuinely in the viewport are revealed, so the scroll animation still
       works normally for everything further down. */
    requestAnimationFrame(() => {
      els.forEach((el) => {
        if (el.classList.contains('is-in')) return;
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); io.unobserve(el); }
      });
    });
  }
})();


/* ---------- Announcement bar rotation ----------
   Cycles the messages rendered by layout/theme.liquid. Conservative by design:
   bails out for a single message; pauses while the tab is hidden (a background tab burning a
   timer for an invisible bar is waste); honours prefers-reduced-motion by not rotating at all. */
(function () {
  const bar = document.getElementById('preview-bar');
  if (!bar || bar.dataset.rotate !== 'true') return;
  const msgs = [...bar.querySelectorAll('.preview-bar__msg')];
  if (msgs.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let i = 0, timer = null;
  const INTERVAL = 4500;
  function step() {
    msgs[i].classList.remove('is-on');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-on');
  }
  function start() { if (!timer) timer = setInterval(step, INTERVAL); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
  bar.addEventListener('mouseenter', stop);   /* pause so a message can actually be read */
  bar.addEventListener('mouseleave', start);
  start();
})();
